import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";

import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

import Homepage from "pages/homepage";
import ServicesOverview from "pages/services-overview";
import TeamProfiles from "pages/team-profiles";
import IndividualServiceDetail from "pages/individual-service-detail";
import ContactConsultationRequest from "pages/contact-consultation-request";
import AboutUs from "pages/about-us";
import NotFound from "pages/NotFound";

const Agent = lazy(() => import("pages/agent"));
const Admin = lazy(() => import("pages/admin"));

const Loading = () => <div style={{ padding: 16 }}>Loading...</div>;

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route
            path="/agent"
            element={
              <Suspense fallback={<Loading />}>
                <Agent />
              </Suspense>
            }
          />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<Loading />}>
                <Admin />
              </Suspense>
            }
          />

          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/services-overview" element={<ServicesOverview />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/team-profiles" element={<TeamProfiles />} />
          <Route path="/individual-service-detail" element={<IndividualServiceDetail />} />
          <Route path="/contact-consultation-request" element={<ContactConsultationRequest />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
